const PhoDatePickerAutomatedTestIds = {
  PHO_DATE_PICKER: 'pho-date-picker',
  PHO_DATE_PICKER_WRAPPER: 'pho-date-picker-wrapper',
  PHO_DATE_PICKER_THREE_DAY_BUTTON: 'pho-date-picker-three-day-picker',
  PHO_DATE_PICKER_ONE_WEEK_BUTTON: 'pho-date-picker-one-week-picker',
  PHO_DATE_PICKER_ONE_MONTH_BUTTON: 'pho-date-picker-one-month-picker',
  PHO_DATE_PICKER_THREE_MONTH_BUTTON: 'pho-date-picker-three-month-picker',
  PHO_DATE_TIME_PICKER_MENU_INPUT_FILTER: 'pho-date-picker-menu-input-filter',
};

const PhoDateTimePickerAutomatedTestIds = {
  PHO_DATE_TIME_PICKER_WRAPPER: 'pho-date-time-picker-wrapper',
  PHO_DATE_PICKER: 'pho-date-time-picker-date',
  SAVE_BUTTON: 'pho-date-time-picker-save-button',
};

export { PhoDatePickerAutomatedTestIds, PhoDateTimePickerAutomatedTestIds };
